import Vue from 'vue'
import App from './App.vue'
import VueMq from 'vue-mq'
 
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    small: 450,
    medium: 1250,
    large: Infinity
  },
  defaultBreakpoint: 'small' // customize this for SSR
})

Vue.config.productionTip = false

// new Vue({
//   render: h => h(App),
// }).$mount('#app')



/* eslint-disable no-new */
Array.prototype.forEach.call(document.querySelectorAll('.vueApp'), function (instance) {
  window['vm' + instance.id] = new Vue({
    el: '#' + instance.id,
    data: window[instance.id],
    render: h => h(
      App,
      {
        props: {
          startdata: instance.id
        }
      })
  })
})